import { render } from "./ProductTitle.vue?vue&type=template&id=7cbba715&scoped=true"
import script from "./ProductTitle.vue?vue&type=script&lang=js"
export * from "./ProductTitle.vue?vue&type=script&lang=js"

import "./ProductTitle.vue?vue&type=style&index=0&id=7cbba715&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbba715"]])

export default __exports__